import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TooltipModule } from 'primeng/tooltip';
import { EditLinks } from '../../../../@core/constants/edit-links';
import { ListLinks } from '../../../../@core/constants/list-links';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';
import { Dialog } from '../../../../@core/services/modal/modal.interfaces';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Task } from '../../../../generated/generated-types';
import { WidgetBaseDetailComponent } from '../../../../shared/components/widget-base-detail/widget-base-detail.component';
import { getEntityEditLink } from '../../../../shared/utils/entity-edit-link';
import { HotkeysService } from '../../../hotkeys/services/hotkeys.service';
import { TaskService } from '../../services/task.service';
import { taskFallbackFields } from './task-fallback-fields';

@Component({
    selector: 'app-task-edit-widget',
    templateUrl: './task-edit-widget.component.html',
    changeDetection: ChangeDetectionStrategy.Default, // Not use OnPush until BaseDetailComponent become OnPush.
    standalone: true,
    providers: [HotkeysService],
    imports: [
        CommonModule,
        WidgetBaseDetailComponent,
        RouterLink,
        TooltipModule,
        // TranslatePipe,
    ]
})
export class TaskEditWidgetComponent extends BaseDetailComponent<Task> implements OnInit, Dialog<Task> {

    resolveWith: (result?: Task) => void;

    linkedEntityEditLink = computed(() => {
        const task = this.detailModelSig();
        return getEntityEditLink(task?.relatedEntity?.type, task?.relatedEntity?.id);
    });

    linkedEntityLinkTooltip = computed(() => {
        const task = this.detailModelSig();
        const label = task?.relatedEntity?.label?.trim();
        if (label) {
            return this.i18nService.translate(_('task.open-related-entity-with-label'), { label });
        }
        return this.i18nService.translate(_('task.open-related-entity'));
    });

    protected route = inject(ActivatedRoute);
    protected router = inject(Router);
    private taskService = inject(TaskService);
    private i18nService = inject(I18nService);
    protected override crudService = this.taskService;


    ngOnInit() {
        this.listLink = ListLinks.TASK;
        this.editLink = EditLinks.TASK;
        this.actionBarLocationId = 'task-detail' as any;

        this.fallbackFields = taskFallbackFields();
        super.ngOnInit();
    }
}
